export default __webpack_public_path__ + "static/pantomime-035f7853bf48789606a44ae10c7a1d22.png";